/* eslint-disable react/prop-types */
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { days } from "./utils";

const size = 24;

const useStyles = makeStyles((theme) => ({
  dayCircle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: "#f1f3f4",
    cursor: "pointer",
  },
  dayCircleSelected: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    cursor: "pointer",
  },
  dayCircleSD: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: theme.palette.grey[400],
    cursor: "pointer",
    pointerEvents: "none",
  },
  dayCircleDisabled: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: size - 4,
    height: size - 4,
    borderRadius: "50%",
    // backgroundColor: theme.palette.grey,
    cursor: "pointer",
    // borderWidth: '1px',
    // borderColor: theme.palette.grey[600]
    border: `2px solid ${theme.palette.grey[400]}`,
    pointerEvents: "none",
  },
  dayLabel: {
    fontSize: 10,
    color: theme.palette.grey[600],
    fontWeight: 500,
  },
  dayLabelDisabled: {
    fontSize: 10,
    color: theme.palette.grey[400],
    fontWeight: 500,
    pointerEvents: "none",
  },
  dayLabelSelected: {
    fontSize: 10,
    color: "white",
    fontWeight: 500,
  },
  dayLabelSD: {
    fontSize: 10,
    color: theme.palette.grey[600],
    fontWeight: 500,
    pointerEvents: "none",
  },
  root: {
    marginTop: 8,
  },
}));

const DaySelectors = (props) => {
  const classes = useStyles();
  const { disabled = false, onSelectionChange, errors, initialValue } = props;
  const [isInitial, setIsInitial] = useState(false);

  const [selected, setSelected] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
  });

  useEffect(() => {
    let res = days
      .filter((d) => initialValue[d.name])
      .reduce((acc, curr) => ({ ...acc, [curr.index]: true }), {});
    setSelected((s) => ({ ...s, ...res }));
    setIsInitial(true);
  }, [initialValue]);

  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(selected, isInitial);
      if (isInitial) {
        setIsInitial(false);
      }
    }
  }, [selected]);

  const handleClick = (item) => {
    const i = item.index;
    setSelected((s) => ({ ...s, [i]: !s[i] }));
  };

  return (
    <>
      <Grid container spacing={1} className={classes.root}>
        {days.map((d) => (
          <Grid item key={d.index}>
            <div
              className={
                disabled
                  ? selected[d.index]
                    ? classes.dayCircleSD
                    : classes.dayCircleDisabled
                  : selected[d.index]
                  ? classes.dayCircleSelected
                  : classes.dayCircle
              }
              onClick={() => handleClick(d)}
            >
              <span
                className={
                  disabled
                    ? selected[d.index]
                      ? classes.dayLabelSD
                      : classes.dayLabel
                    : selected[d.index]
                    ? classes.dayLabelSelected
                    : classes.dayLabel
                }
              >
                {d.short}
              </span>
            </div>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default DaySelectors;
